/* Teach a Kid to Fish — behaviour for the shared product card (snippets/taktf-product-card.liquid):
   photo arrows and dots, Add to Cart (updates the cart drawer) and Buy Now.
   Mirrors the card script in sections/taktf-shop-page.liquid. */
(function () {
  if (window.taktfCards) return;
  window.taktfCards = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var toastEl;
  var toastTimer;

  function toast(message, isError) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'taktf taktf-sp__toast taktf-cards-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      toastEl.innerHTML =
        '<svg class="taktf-icon" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Zm-1.2 14.2-4-4 1.4-1.4 2.6 2.6 5.6-5.6 1.4 1.4-7 7Z"/></svg><span></span>';
      document.body.appendChild(toastEl);
    }
    toastEl.querySelector('span').textContent = message;
    toastEl.classList.toggle('is-error', !!isError);
    toastEl.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-visible'); }, 3500);
  }

  function showImage(card, index) {
    var img = card.querySelector('[data-sp-img]');
    var images;
    try { images = JSON.parse(img.dataset.images || '[]'); } catch (e) { images = []; }
    if (images.length < 2) return;
    index = (index + images.length) % images.length;
    card.dataset.slide = index;
    img.removeAttribute('srcset');
    img.style.opacity = '0.4';
    setTimeout(function () {
      img.src = images[index];
      img.style.opacity = '1';
    }, 80);
    card.querySelector('[data-sp-counter]').textContent = (index + 1) + ' / ' + images.length;
    card.querySelectorAll('[data-sp-dot]').forEach(function (dot, i) { dot.classList.toggle('is-active', i === index); });
  }

  function addToCart(button) {
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(button.dataset.spAdd), quantity: 1 }] })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
      .then(function (res) {
        if (!res.ok || res.json.status) throw new Error(res.json.description || res.json.message || 'Could not add to cart.');
        var main = document.getElementById('MainContent');
        if (main && main.dataset.template === 'cart') { window.location.reload(); return; }
        document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: {}, sourceId: button.dataset.spAdd, data: { source: 'taktf-product-card', itemCount: 1 } } }));
        toast('Added ' + button.dataset.title + ' to cart!');
      })
      .catch(function (err) { toast(err.message, true); })
      .finally(function () {
        button.disabled = false;
        button.removeAttribute('aria-busy');
      });
  }

  document.addEventListener('click', function (e) {
    var host = e.target.closest('[data-taktf-cards]');
    if (!host) return;
    var t = e.target;
    var step = t.closest('[data-sp-step]');
    if (step) {
      e.preventDefault();
      var card = step.closest('[data-sp-card]');
      showImage(card, Number(card.dataset.slide) + Number(step.dataset.spStep));
      return;
    }
    var dot = t.closest('[data-sp-dot]');
    if (dot) { e.preventDefault(); showImage(dot.closest('[data-sp-card]'), Number(dot.dataset.spDot)); return; }
    var add = t.closest('[data-sp-add]');
    if (add) { e.preventDefault(); addToCart(add); return; }
    var buy = t.closest('[data-sp-buy]');
    if (buy) { e.preventDefault(); window.location.href = root + 'cart/' + buy.dataset.spBuy + ':1'; }
  });
})();
